// export const banks = [
//   { name: 'ABC Bank', code: 'ABC' },
//   { name: 'Federal Bank', code: 'Federal Bank' },
//   { name: 'XYZ Bank', code: 'XYZ' }
// ]

// export const branch = [
//   { name: 'ABC Branch', code: 'ABC' },
//   { name: 'Test Branch', code: 'Test Bank' },
//   { name: 'XYZ Branch', code: 'XYZ' }
// ]



export const bankTypes = [
  { label: 'Bank', value: 'Bank' },
  { label: 'Union', value: 'Union' }
]
